export const TIMESTAMP = 'YYYY-MM-DDTHH:mm:ss';
export const UTC_TIMESTAMP = 'YYYY-MM-DDTHH:mm:ss[Z]';
export const UTC_TIMEZONE_TIMESTAMP = 'YYYY-MM-DDTHH:mm:ss[+00:00]';
export const DATE_TIMEZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_MONTH_READABLE_FORMAT = 'YYYY/MMM/DD';
export const TOOLTIP_DATETIME_READABLE = 'DD/MMM/YYYY HH:mm';
export const TOOLTIP_DATE_READABLE = 'DD/MMM/YYYY';
export const CUSTOM_TIMEZONE_FORMAT = 'YYYY-MM-DD HH:mm (UTCZ)';
